import logo from './CrunchbaseLogo.png';

const Logo = () => (
  <a href={'http://www.crunchbase.com/'} target='_blank' rel='noreferrer'>
    <img alt='Crunchbase Logo' src={logo} />
  </a>
);

export default Logo;
